<template>
    <div id="monitor-block"
        class="monitor-container"
        :class="{
            'monitor-container--map': is_monitor_open_emap
        }"
    >
        <Logo v-show="!is_monitor_open_emap"
            :show_custom="!is_pub"
            :custom_logo="custom_logo"
            color="Blue"
            :cwa_logo_src="`/static/UIUX/images/header/${logo_file_name}_Blue_web@3x.png`"
        />
        <template v-if="[15, 109, 16].includes(monitor_type)">
            <Rainfall
                :key="monitor_type"
                :default_value="monitor_type"
            />
        </template>
        <template v-else-if="[14, 108].includes(monitor_type)">
            <SurfaceWeather
                :default_value="monitor_type"
            />
        </template>
        <template v-else-if="[112, 196, 202, 208].includes(monitor_type)">
            <Buoy 
                :default_value="monitor_type"
            />
        </template>
        <template v-else-if="[113, 199, 205, 211].includes(monitor_type)">
            <Tide 
                :default_value="monitor_type"
            />
        </template>

        <!-- tra -->
        <template v-else-if="monitor_type === 61">
            <h2>監控總覽資訊</h2>
            <ChildFocalMonitor
                :default_value="26"
                :key="`${monitor_type}26`"
                :in_overview_page="true"
            />
            <ChildFocalMonitor
                :default_value="27"
                :key="`${monitor_type}27`"
                :in_overview_page="true"
            />
            <LandslideTRA
                :key="`${monitor_type}_49`"
                default_value="49"
                :in_overview_page="true"
            />
        </template>
        <template v-else-if="monitor_type === 26">
            <ChildFocalMonitor
                :default_value="monitor_type"
                :key="monitor_type"
            />
        </template>
        <template v-else-if="monitor_type === 27">
            <ChildFocalMonitor
                :default_value="monitor_type"
                :key="monitor_type"
            />
        </template>
        <template v-else-if="monitor_type === 49">
            <LandslideTRA
                :key="monitor_type"
                :default_value="monitor_type"
            />
        </template>
        <template v-else-if="monitor_type === 232">
            <LightningTRA />
        </template>
        <template v-else-if="monitor_type === 41">
            <ChildRouteRainfall
                :default_value="monitor_type"
                :key="monitor_type"
                option_local_storage_name="station_rainfall_option"
            />
        </template>
        <template v-else-if="monitor_type === 43">
            <ChildRouteRainfall
                :default_value="monitor_type"
                :key="monitor_type"
                option_local_storage_name="mileage_rainfall_option"
            />
        </template>
        <template v-else-if="monitor_type === 45">
            <ChildRouteRainfall
                :default_value="monitor_type"
                :key="monitor_type"
                option_local_storage_name="bridge_rainfall_option"
            />
        </template>
        <template v-else-if="monitor_type === 47">
            <ChildRouteRainfall
                :default_value="monitor_type"
                :key="monitor_type"
                option_local_storage_name="tunnel_rainfall_option"
            />
        </template>
        <template v-else-if="monitor_type === 357">
            <ChildRouteRainfall
                :default_value="monitor_type"
                :key="monitor_type"
                option_local_storage_name="station_rainfall_option"
                :enable_route_filter="false"
            />
        </template>

        <!-- wra -->
        <template v-else-if="monitor_type === 30">
            <ChildNoneFeature
                :key="monitor_type"
                :default_value="monitor_type"
            />
        </template>
        <template v-else-if="monitor_type === 28">
            <ChildNoneFeature
                :key="monitor_type"
                :default_value="monitor_type"
            />
        </template>
        <template v-else-if="monitor_type === 29">
            <ChildNoneFeature
                :key="monitor_type"
                :default_value="monitor_type"
            />
        </template>
        <template v-else-if="monitor_type === 38">
            <ChildNoneFeature
                :key="monitor_type"
                :default_value="monitor_type"
            />
        </template>
        <template v-else-if="monitor_type === 331">
            <ChildNoneFeature
                :key="monitor_type"
                :default_value="monitor_type"
            />
        </template>
        <template v-else-if="monitor_type === 353">
            <DatetimeMerge
                :default_value="monitor_type"
                :key="monitor_type"
            />
        </template>
        <template v-else-if="monitor_type === 354">
            <DatetimeMerge
                :default_value="monitor_type"
                :key="monitor_type"
            />
        </template>
        <template v-else-if="monitor_type === 355">
            <DatetimeMerge
                :default_value="monitor_type"
                :key="monitor_type"
            />
        </template>
        <template v-else-if="monitor_type === 356">
            <DatetimeMerge
                :default_value="monitor_type"
                :key="monitor_type"
            />
        </template>

        <!-- caa -->
        <template v-else-if="monitor_type === 238">
            <RealTimeEcho />
        </template>
        <template v-else-if="monitor_type === 254">
            <RealTimeEchoSimple />
        </template>
        <template v-else-if="monitor_type === 234">
            <LightningCAA />
        </template>

        <!-- freeway -->
        <template v-else-if="monitor_type === 128">
            <ChildAreaRainfall
                :key="monitor_type"
                :default_value="monitor_type"
                option_local_storage_name="mileage_rainfall_option"
            />
        </template>
        <template v-else-if="monitor_type === 129">
            <ChildAreaRainfallQPE
                :key="monitor_type"
                :default_value="monitor_type"
                option_local_storage_name="mileage_rainfall_qpe_option"
                filter_json_key="國道名稱"
            />
        </template>
        <template v-else-if="monitor_type === 130">
            <MileageRainfallDaily />
        </template>
        <template v-else-if="monitor_type === 131">
            <ChildAreaRainfall
                :key="monitor_type"
                :default_value="monitor_type"
                option_local_storage_name="ramp_rainfall_option"
            />
        </template>
        <template v-else-if="monitor_type === 132">
            <ChildAreaRainfallQPE
                :key="monitor_type"
                :default_value="monitor_type"
                option_local_storage_name="ramp_rainfall_qpe_option"
                filter_json_key="國道名稱"
            />
        </template>
        <template v-else-if="monitor_type === 133">
            <ChildAreaRainfall
                :key="monitor_type"
                :default_value="monitor_type"
                option_local_storage_name="service_area_option"
            />
        </template>
        <template v-else-if="monitor_type === 134">
            <ChildAreaRainfallQPE
                :key="monitor_type"
                :default_value="monitor_type"
                option_local_storage_name="service_area_rainfall_qpe_option"
                filter_json_key="國道名稱"
            />
        </template>
        <template v-else-if="monitor_type === 135">
            <ChildNoneFeature
                :key="monitor_type"
                :default_value="monitor_type"
            />
        </template>
        <template v-else-if="monitor_type === 214">
            <GroundVisbility />
        </template>

        <!-- nmo -->
        <template v-else-if="monitor_type === 93">
            <ChildNomalAlert 
                :key="monitor_type"
                :default_value="monitor_type"
            />
        </template>
        <template v-else-if="monitor_type === 94">
            <ChildNomalAlert 
                :key="monitor_type"
                :default_value="monitor_type"
            />
        </template>
        <template v-else-if="monitor_type === 95">
            <ChildNomalAlert 
                :key="monitor_type"
                :default_value="monitor_type"
            />
        </template>

        <!-- port -->
        <template v-else-if="monitor_type === 251">
            <PortMonitor />
        </template>
        <template v-else-if="monitor_type === 236">
            <LightningPORT />
        </template>

        <!-- pro -->
        <template v-else-if="monitor_type == 248">
            <ShortTermRainfall />
        </template>

        <template v-else-if="monitor_type == 267">
            <RadarStatus />
        </template>

        <!-- swcb -->
        <template v-else-if="monitor_type == 91">
            <LandslideSWCB 
                :key="monitor_type"
                :default_value="monitor_type"
            />
        </template>
        <template v-else-if="monitor_type == 261">
            <LandslideTRA
                :key="monitor_type"
                :default_value="monitor_type"
                :custom_alert_text="{1:'紅色',2:'黃色'}"
            />
        </template>

        <!-- tbroc -->
        <template v-else-if="monitor_type == 252">
            <!-- no filter -->
            <ScenicAreaAlert />
        </template>
        <template v-else-if="monitor_type == 253">
            <ScenicAreaManagement />
        </template>

        <!-- thb -->
        <template v-else-if="monitor_type === 255">
            <!-- 監控表格總覽，需注意未來子表格的 default_value 可能更換，且總覽只顯示有警示的資料 -->
            <ChildNomalAlert 
                :key="`${monitor_type}_2`"
                :default_value="2"
                :in_overview_page="true"
                :show_download_doc_btn="true"
            />
            <ChildNomalAlert 
                :key="`${monitor_type}_4`"
                :default_value="4"
                :in_overview_page="true"
                :show_download_doc_btn="true"
            />
            <ChildNomalAlert 
                :key="`${monitor_type}_3`"
                :default_value="3"
                :in_overview_page="true"
                :show_download_doc_btn="true"
            />
            <ChildNomalAlert 
                :key="`${monitor_type}_5`"
                :default_value="5"
                :in_overview_page="true"
                :show_download_doc_btn="true"
            />
            <ChildNomalAlert 
                :key="`${monitor_type}_8`"
                :default_value="8"
                :in_overview_page="true"
                :show_download_doc_btn="true"
                :show_customize_explanation="true"
            >
                <template #explanation_remarks>
                    <ol>
                        <li>「--」 表示該欄位無資料。</li>
                        <li>此表之路段雨量來自定量降雨估計(QPE)，為結合雷達與雨量站觀測資料的估計值，敬請謹慎使用。</li>
                    </ol>
                </template>
            </ChildNomalAlert>
            <WaveMonitor 
                :key="`${monitor_type}_249`"
                :default_value="249"
                :in_overview_page="true"
                :show_download_doc_btn="true"
            />
        </template>
        <template v-else-if="monitor_type === 2">
            <ChildNomalAlert 
                :key="monitor_type"
                :default_value="monitor_type"
                :show_download_doc_btn="true"
            />
        </template>
        <template v-else-if="monitor_type === 4">
            <ChildNomalAlert 
                :key="monitor_type"
                :default_value="monitor_type"
                :show_download_doc_btn="true"
            />
        </template>
        <template v-else-if="monitor_type === 3">
            <ChildNomalAlert 
                :key="monitor_type"
                :default_value="monitor_type"
                :show_download_doc_btn="true"
            />
        </template>
        <template v-else-if="monitor_type === 5">
            <ChildNomalAlert 
                :key="monitor_type"
                :default_value="monitor_type"
                :show_download_doc_btn="true"
            />
        </template>
        <template v-else-if="monitor_type === 8">
            <ChildNomalAlert 
                :key="monitor_type"
                :default_value="monitor_type"
                :show_download_doc_btn="true"
                :show_customize_explanation="true"
            >
                <template #explanation_remarks>
                    <ol>
                        <li>「--」 表示該欄位無資料。</li>
                        <li>此表之路段雨量來自定量降雨估計(QPE)，為結合雷達與雨量站觀測資料的估計值，敬請謹慎使用。</li>
                    </ol>
                </template>
            </ChildNomalAlert>
        </template>
        <template v-else-if="[9, 249].includes(monitor_type)">
            <WaveMonitor 
                :key="monitor_type"
                :default_value="monitor_type"
            />
        </template>
        <template v-else-if="monitor_type == 11">
            <BranchRainfall />
        </template>
        <template v-else-if="monitor_type == 12">
            <ChildNoneFeature
                :key="monitor_type"
                :default_value="monitor_type"
                :show_download_doc_btn="true"
            />
        </template>
        <template v-else-if="monitor_type == 13">
            <SurfaceWeatherTHB />
        </template>
        <template v-else-if="monitor_type == 260">
            <ChildNomalAlert 
                :key="monitor_type"
                :default_value="monitor_type"
                :show_customize_explanation="true"
            >
                <template #explanation_remarks>
                    <div class="explanation">
                        <span>1. 「--」 表示該欄位無資料。</span><br>
                        <span>2. 此表之路段雨量來自定量降雨估計(QPE)，</span><br>
                        <span>為結合雷達與雨量站觀測資料的估計值，敬請謹慎使用。</span>
                    </div>
                </template>
            </ChildNomalAlert>
        </template>
        <template v-else-if="monitor_type === 262">
            <THBMileageRainfallDaily />
        </template>
        <template v-else-if="monitor_type === 330">
            <SuhuaMonitor />
        </template>
        <template v-else-if="monitor_type === 297">
            <LandslideTRA 
                :key="monitor_type"
                :default_value="monitor_type"
            />
        </template>
        <template v-else-if="monitor_type === 329">
            <LandslideSWCB
                :key="monitor_type"
                :default_value="monitor_type"
            />
        </template>
        <template v-else-if="monitor_type === 332">
            <LandslideSWCB
                :key="monitor_type"
                :default_value="monitor_type"
            />
        </template>
        <!-- thsr -->
        <template v-else-if="[256, 257].includes(monitor_type)">
            <ThsrMonitor
                :key="monitor_type"
                :default_value="monitor_type"
            />
        </template>
        <template v-else-if="monitor_type === 259">
            <ThsrMonitor v-for="default_value in [256, 257]"
                :key="`overview_${default_value}`"
                :default_value="default_value"
                :in_overview_page="true"
            />
        </template>
        <template v-else-if="monitor_type === 327">
            <ChildFocalMonitor
                :default_value="monitor_type"
                :key="monitor_type"
            />
        </template>
        <template v-else-if="monitor_type === 328">
            <ChildFocalMonitor
                :default_value="monitor_type"
                :key="monitor_type"
            />
        </template>

        <!-- MPB -->
        <template v-else-if="monitor_type === 150">
            <MpbMonitor 
                :key="monitor_type"
                :default_value="monitor_type"
            />
        </template>
        <template v-else-if="monitor_type === 151">
            <MpbMonitor 
                :key="monitor_type"
                :default_value="monitor_type"
            />
        </template>

        <!-- KEELUNG -->
        <template v-else-if="monitor_type == 280">
            <LandslideSWCB 
                :key="monitor_type"
                :default_value="monitor_type"
            />
        </template>

        <!-- 各縣市行政區雨量警戒 -->
        <template v-else-if="[335, 336, 337, 338, 339, 340, 341, 342, 343, 344, 345, 346, 347, 348, 349, 350].includes(monitor_type)">
            <ChildNomalAlert 
                :key="monitor_type"
                :default_value="monitor_type"
            />
        </template>

        <!-- tpc -->
        <template v-else-if="monitor_type == 115">
            <ChildNomalAlert 
                :key="monitor_type"
                :default_value="monitor_type"
            />
        </template>
        <template v-else-if="monitor_type == 114">
            <ChildNomalAlert 
                :key="monitor_type"
                :default_value="monitor_type"
            />
        </template>
        <template v-else-if="monitor_type == 117">
            <ChildNomalAlert 
                :key="monitor_type"
                :default_value="monitor_type"
            />
        </template>
        <template v-else-if="monitor_type == 116">
            <ChildNomalAlert 
                :key="monitor_type"
                :default_value="monitor_type"
            />
        </template> 
        <template v-else-if="monitor_type == 118">
            <ChildNomalAlert 
                :key="monitor_type"
                :default_value="monitor_type"
            />
        </template>
        <template v-else-if="monitor_type == 281">
            <LandslideSWCB 
                :key="monitor_type"
                :default_value="monitor_type"
            />
        </template>

        <!-- ntpc -->
        <template v-else-if="monitor_type === 63">
            <ChildNomalAlert 
                :key="monitor_type"
                :default_value="monitor_type"
            />
        </template>
        <template v-else-if="monitor_type === 65">
            <ChildNomalAlert 
                :key="monitor_type"
                :default_value="monitor_type"
            />
        </template>
        <template v-else-if="monitor_type === 67">
            <ChildNomalAlert 
                :key="monitor_type"
                :default_value="monitor_type"
            />
        </template>
        <template v-else-if="monitor_type === 69">
            <ChildNomalAlert 
                :key="monitor_type"
                :default_value="monitor_type"
            />
        </template> 
        <template v-else-if="monitor_type === 71">
            <ChildNomalAlert 
                :key="monitor_type"
                :default_value="monitor_type"
            />
        </template>  
        <template v-else-if="monitor_type === 73">
            <ChildNomalAlert 
                :key="monitor_type"
                :default_value="monitor_type"
            />
        </template>  
        <template v-else-if="monitor_type === 75">
            <ChildNomalAlert 
                :key="monitor_type"
                :default_value="monitor_type"
            />
        </template>
        <template v-else-if="monitor_type === 77">
            <CoastalWarning />
        </template>
        <template v-else-if="monitor_type == 282">
            <LandslideSWCB 
                :key="monitor_type"
                :default_value="monitor_type"
            />
        </template>

        <!-- taoyuan -->
        <template v-else-if="monitor_type == 119">
            <ChildNomalAlert 
                :key="monitor_type"
                :default_value="monitor_type"
            />
        </template>
        <template v-else-if="monitor_type == 120">
            <ChildNomalAlert 
                :key="monitor_type"
                :default_value="monitor_type"
            />
        </template>
        <template v-else-if="monitor_type == 283">
            <LandslideSWCB 
                :key="monitor_type"
                :default_value="monitor_type"
            />
        </template>

        <!-- HSINCHU_CITY -->
        <template v-else-if="monitor_type == 284">
            <LandslideSWCB 
                :key="monitor_type"
                :default_value="monitor_type"
            />
        </template>

        <!-- MIAOLI -->
        <template v-else-if="monitor_type == 285">
            <LandslideSWCB 
                :key="monitor_type"
                :default_value="monitor_type"
            />
        </template>

        <!-- TAICHUNG -->
        <template v-else-if="monitor_type == 286">
            <LandslideSWCB 
                :key="monitor_type"
                :default_value="monitor_type"
            />
        </template>

        <!-- NANTOU -->
        <template v-else-if="monitor_type == 287">
            <LandslideSWCB 
                :key="monitor_type"
                :default_value="monitor_type"
            />
        </template>

        <!-- 彰化縣政府 -->
        <template v-else-if="monitor_type == 288">
            <LandslideSWCB 
                :key="monitor_type"
                :default_value="monitor_type"
            />
        </template>

        <!-- 雲林縣政府 -->
        <template v-else-if="monitor_type == 289">
            <LandslideSWCB 
                :key="monitor_type"
                :default_value="monitor_type"
            />
        </template>

        <!-- 嘉義縣政府 -->
        <template v-else-if="monitor_type == 290">
            <LandslideSWCB 
                :key="monitor_type"
                :default_value="monitor_type"
            />
        </template>

        <!-- tainan -->
        <template v-else-if="monitor_type === 87">
            <ChildNomalAlert 
                :key="monitor_type"
                :default_value="monitor_type"
            />
        </template>
        <template v-else-if="monitor_type === 89">
            <ChildNomalAlert 
                :key="monitor_type"
                :default_value="monitor_type"
            />
        </template>
        <template v-else-if="monitor_type == 291">
            <LandslideSWCB 
                :key="monitor_type"
                :default_value="monitor_type"
            />
        </template>

        <!-- khc -->
        <template v-else-if="monitor_type === 140">
            <ChildNomalAlert 
                :key="monitor_type"
                :default_value="monitor_type"
            />
        </template>
        <template v-else-if="monitor_type === 143">
            <ChildNomalAlert 
                :key="monitor_type"
                :default_value="monitor_type"
            />
        </template>
        <template v-else-if="monitor_type == 292">
            <LandslideSWCB 
                :key="monitor_type"
                :default_value="monitor_type"
            />
        </template>

        <!-- 屏東縣政府 -->
        <template v-else-if="monitor_type == 293">
            <LandslideSWCB 
                :key="monitor_type"
                :default_value="monitor_type"
            />
        </template>

        <!-- 宜蘭縣政府 -->
        <template v-else-if="monitor_type == 294">
            <LandslideSWCB 
                :key="monitor_type"
                :default_value="monitor_type"
            />
        </template>

        <!-- hlc -->
        <template v-else-if="monitor_type === 141">
            <ChildNomalAlert 
                :key="monitor_type"
                :default_value="monitor_type"
            />
        </template>
        <template v-else-if="monitor_type === 142">
            <ChildNomalAlert 
                :key="monitor_type"
                :default_value="monitor_type"
            />
        </template>
        <template v-else-if="monitor_type == 295">
            <LandslideSWCB 
                :key="monitor_type"
                :default_value="monitor_type"
            />
        </template>

        <!-- taitung -->
        <template v-if="monitor_type == 125">
            <ChildNomalAlert 
                :key="monitor_type"
                :default_value="monitor_type"
            />
        </template>
        <template v-else-if="monitor_type == 126">
            <ChildNomalAlert 
                :key="monitor_type"
                :default_value="monitor_type"
            />
        </template>
        <template v-else-if="monitor_type == 127">
            <ChildNomalAlert 
                :key="monitor_type"
                :default_value="monitor_type"
            />
        </template>
        <template v-else-if="monitor_type == 296">
            <LandslideSWCB 
                :key="monitor_type"
                :default_value="monitor_type"
            />
        </template>

        <!-- 模組化監控表格 -->
        <template v-else-if="is_custom_monitor">
            <CustomTemplate />
        </template>
    </div>
</template>
<script>
    import { mapState, mapGetters } from 'vuex';

    import Logo from "../logo.vue"

    export default {
        name: 'MonitorBlock',
        
        components: {
            Rainfall: () => import(/* webpackPrefetch: true */ './common/rainfall.vue'),
            SurfaceWeather: () => import(/* webpackPrefetch: true */ './common/surface_weather.vue'),
            ChildNomalAlert: () => import('./common/child_nomal_alert.vue'),
            Buoy: () => import('./common/buoy.vue'),
            Tide: () => import('./common/tide.vue'),
            ChildNoneFeature: () => import('./common/child_none_feature.vue'),
            DatetimeMerge:()=>import('./common/datetime_merge.vue'),
            LightningCAA: () => import('./caa/lightning.vue'),
            RealTimeEcho: () => import('./caa/realtime_echo.vue'),
            RealTimeEchoSimple: () => import('./caa/realtime_echo_simple.vue'),
            ChildAreaRainfall: () => import('./freeway/child_area_rainfall.vue'),
            ChildAreaRainfallQPE: () => import('./freeway/child_area_rainfall_qpe.vue'),
            MileageRainfallDaily: () => import('./freeway/mileage_rainfall_daily.vue'),
            GroundVisbility: () => import('./freeway/ground_visibility.vue'),
            CoastalWarning: () => import('./ntpc/coastal_warning.vue'),
            PortMonitor: () => import('./port/port_monitor.vue'),
            LightningPORT: () => import('./port/lightning.vue'),
            ShortTermRainfall: () => import('./pro/short_term_rainfall.vue'),
            RadarStatus: () => import('./pro/radar_status.vue'),
            LandslideSWCB: () => import('./swcb/landslide.vue'),
            ScenicAreaManagement: () => import('./tbroc/scenic_area_management.vue'),
            ScenicAreaAlert: () => import('./tbroc/scenic_area_alert.vue'),
            WaveMonitor: () => import('./thb/wave_monitor.vue'),
            THBMileageRainfallDaily: () => import('./thb/mileage_rainfall_daily.vue'),
            BranchRainfall: () => import('./thb/branch_rainfall.vue'),
            SurfaceWeatherTHB: () => import('./thb/surface_weather.vue'),
            ChildFocalMonitor: () => import('./tra/child_focal_monitor.vue'),
            ChildRouteRainfall: () => import('./tra/child_route_rainfall.vue'),
            LightningTRA: () => import('./tra/lightning.vue'),
            LandslideTRA: () => import('./tra/landslide.vue'),
            ThsrMonitor: () => import('./thsr/thsr_monitor.vue'),
            CustomTemplate: () => import('./custom_template.vue'),
            SuhuaMonitor: () => import('./thb/suhua_monitor.vue'),
            MpbMonitor: () => import('./mpb/mpb_monitor.vue'),
            Logo
        },

        data() {
            return {
                init_opened_layers: [],
                init_items: [],
                checked_selectors: {},
                selected_items: [],	
                init_checked_item: {},

            }
        },

        computed: {
            ...mapState([
                'client_name',
            ]),

            ...mapState('monitor', [
                'monitor_type',
                'is_custom_monitor'
            ]),

            ...mapState('emap-monitor', [
                'is_monitor_open_emap',
            ]),

            ...mapGetters([
                'is_pub',
                'is_mobile_width',
                'logo_file_name',
                'is_case_mode',
            ]),

            custom_logo() {
                return this.is_mobile_width ? `/static/${this.client_name}/images/header/logo_m.png` : `/static/${this.client_name}/images/header/logo.png`
            }
        },
    }
</script>

<style lang="scss" scoped>
    @import '../../../css/mixin';

    .monitor-container {
        overflow: auto;
        height: 100vh;

        &--map {
            overflow: auto;
            height: 50%;
        }
    }

    h2 {
        padding: 0 1rem;
    }
</style>

<style lang="scss">
    @import '../../../css/mixin';

    .description-dot {
        display: inline-block;
        width: 1em;
        height: 1em;
        border-radius: 50%;
    }
</style>